(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[169],{

/***/ 79020:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/swap/[[...slug]]",
      function () {
        return __webpack_require__(31998);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ TxErrorModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70070);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74454);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45180);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59172);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46206);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96138);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47808);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65186);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24156);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53984);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53857);
/* harmony import */ var _constants_transaction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74292);




var TxErrorModal = function(param) {
    var txState = param.txState, setTxState = param.setTxState, error = param.error;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_, {
            isOpen: txState === _constants_transaction__WEBPACK_IMPORTED_MODULE_1__/* .TransactionState.ERROR */ .g.ERROR,
            onClose: function() {
                setTxState();
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .ModalOverlay */ .Z, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ModalContent */ .h, {
                    p: 10,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .ModalCloseButton */ .o, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .ModalBody */ .f, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .VStack */ .g, {
                                spacing: 5,
                                m: 5,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .J, {
                                        as: react_icons_ai__WEBPACK_IMPORTED_MODULE_9__/* .AiFillCloseCircle */ .LHV,
                                        boxSize: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Heading */ .X, {
                                        as: "h2",
                                        size: "md",
                                        children: "Transaction Failed"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                        children: error
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .z, {
                                        colorScheme: "whiteAlpha.600",
                                        variant: "outline",
                                        mt: 5,
                                        mr: 3,
                                        onClick: function() {
                                            setTxState();
                                        },
                                        children: "Close"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 47878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ SelectToken; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/chunk-CHB4ZXZG.mjs + 5 modules
var chunk_CHB4ZXZG = __webpack_require__(44853);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-6CSUKJP7.mjs
var chunk_6CSUKJP7 = __webpack_require__(62824);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chunk-PXXQR4UW.mjs
var chunk_PXXQR4UW = __webpack_require__(96020);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-MPFPK3CX.mjs
var chunk_MPFPK3CX = __webpack_require__(88828);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chunk-3HLJVDJ7.mjs
var chunk_3HLJVDJ7 = __webpack_require__(12360);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-6FWJQRCB.mjs
var chunk_6FWJQRCB = __webpack_require__(60480);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chunk-NAA7TEES.mjs + 3 modules
var chunk_NAA7TEES = __webpack_require__(53984);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chunk-7MR544DA.mjs
var chunk_7MR544DA = __webpack_require__(93278);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/number-input/dist/chunk-GIDWA67N.mjs + 6 modules
var chunk_GIDWA67N = __webpack_require__(41325);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chunk-RGZJAHFA.mjs
var chunk_RGZJAHFA = __webpack_require__(51088);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-HUQHYERK.mjs
var chunk_HUQHYERK = __webpack_require__(14040);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-P74GIWPW.mjs
var chunk_P74GIWPW = __webpack_require__(24156);
// EXTERNAL MODULE: ./components/Tokens/TokenImage.tsx
var TokenImage = __webpack_require__(78732);
;// CONCATENATED MODULE: ./components/Tokens/TokenLogo.tsx



var tokenImage = function(token) {
    return "tokens/".concat(token.chainId, "/").concat(token.address, ".png");
};
var TokenLogo = function(param) {
    var token = param.token;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_MPFPK3CX/* Flex */.k, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_HUQHYERK/* HStack */.U, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenImage/* TokenImage */.O, {
                    address: "".concat(token.address),
                    boxSize: {
                        base: 5,
                        lg: 6
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                    fontSize: {
                        base: 14,
                        lg: 16
                    },
                    children: token.symbol
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/Tokens/SelectTokenButton.tsx





var SelectTokenButton = function(param) {
    var token = param.token, _onClick = param._onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_NAA7TEES/* Button */.z, {
        onClick: _onClick,
        size: {
            base: "sm",
            lg: "lg"
        },
        px: 2,
        bg: "whiteAlpha.200",
        _hover: {
            bg: "whiteAlpha.200"
        },
        _active: {
            bg: "whiteAlpha.200"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_HUQHYERK/* HStack */.U, {
            spacing: {
                base: 3,
                lg: 6
            },
            children: [
                token ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenLogo, {
                    token: token
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                    ml: 3,
                    mr: -4,
                    children: "Select"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6FWJQRCB/* Spacer */.L, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_RGZJAHFA/* ChevronDownIcon */.v, {})
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chunk-XOVTCM5B.mjs
var chunk_XOVTCM5B = __webpack_require__(3977);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-UUGUEMMH.mjs + 2 modules
var chunk_UUGUEMMH = __webpack_require__(70070);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-OWW5MU75.mjs + 1 modules
var chunk_OWW5MU75 = __webpack_require__(74454);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-66WFFNY3.mjs + 3 modules
var chunk_66WFFNY3 = __webpack_require__(45180);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-YBA5A33G.mjs
var chunk_YBA5A33G = __webpack_require__(58697);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-YLPWWAYV.mjs
var chunk_YLPWWAYV = __webpack_require__(59172);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-PVJ72NKC.mjs
var chunk_PVJ72NKC = __webpack_require__(46206);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chunk-NYZMXHN6.mjs
var chunk_NYZMXHN6 = __webpack_require__(38322);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chunk-GYFRIY2Z.mjs
var chunk_GYFRIY2Z = __webpack_require__(34598);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-YGVX4ESO.mjs
var chunk_YGVX4ESO = __webpack_require__(88977);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/chunk-E77276RR.mjs + 2 modules
var chunk_E77276RR = __webpack_require__(57922);
// EXTERNAL MODULE: ./utils/token/formatBalance.ts
var formatBalance = __webpack_require__(95487);
;// CONCATENATED MODULE: ./components/Swap/TokenList.tsx



var TokenList = function(param) {
    var token = param.token, _onClick = param._onClick, balance = param.balance;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6CSUKJP7/* Box */.xu, {
            as: "button",
            cursor: "pointer",
            _focus: {
                bg: "whiteAlpha.300"
            },
            padding: 2,
            rounded: 8,
            w: "100%",
            onClick: function() {
                return _onClick(token);
            },
            _hover: {
                bg: "whiteAlpha.100"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_HUQHYERK/* HStack */.U, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_E77276RR/* Image */.E, {
                                src: "/tokens/".concat(token.chainId, "/").concat(token.address, ".png"),
                                alt: token.name,
                                boxSize: {
                                    base: 6,
                                    lg: 8
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                children: token.symbol
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6FWJQRCB/* Spacer */.L, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_HUQHYERK/* HStack */.U, {
                        spacing: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                            children: (0,formatBalance/* getDisplayBalanceAmount */.hr)(balance, token.decimal)
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/Tokens/SelectTokenModal.tsx






var SelectTokenModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, selectToken = param.selectToken, balances = param.balances, tokens = param.tokens;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var ref = (0,react.useState)(), search = ref[0], setSearchName = ref[1];
    var filteredTokens = (0,react.useMemo)(function() {
        if (!search || search === "") return tokens;
        return tokens.filter(function(token) {
            return token.name.toLowerCase().includes(search.toLowerCase());
        });
    }, [
        search,
        tokens
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_UUGUEMMH/* Modal */.u_, {
            blockScrollOnMount: false,
            isOpen: isOpen,
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_OWW5MU75/* ModalOverlay */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_66WFFNY3/* ModalContent */.h, {
                    bg: "gray.700",
                    mx: {
                        base: 4,
                        lg: "inherit"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_YBA5A33G/* ModalHeader */.x, {
                            fontSize: {
                                base: 16,
                                lg: 20
                            },
                            children: t("Select a Token")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_YLPWWAYV/* ModalCloseButton */.o, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_PVJ72NKC/* ModalBody */.f, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_7MR544DA/* InputGroup */.B, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_NYZMXHN6/* InputLeftElement */.Z, {
                                            pointerEvents: "none",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_XOVTCM5B/* SearchIcon */.W, {
                                                color: "gray.300"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_GYFRIY2Z/* Input */.I, {
                                            fontSize: {
                                                base: 14,
                                                lg: 16
                                            },
                                            type: "text",
                                            placeholder: t("Search name or paste the token address"),
                                            onChange: function(event) {
                                                return setSearchName(event.target.value);
                                            },
                                            value: search
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                    my: 3,
                                    fontSize: {
                                        base: 14,
                                        lg: 16
                                    },
                                    children: t("Token name")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_YGVX4ESO/* Divider */.i, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6CSUKJP7/* Box */.xu, {
                                    overflowY: "scroll",
                                    maxH: 400,
                                    fontSize: {
                                        base: 14,
                                        lg: 16
                                    },
                                    children: balances && (filteredTokens === null || filteredTokens === void 0 ? void 0 : filteredTokens.map(function(token, i) {
                                        var ref;
                                        var balance = (ref = balances.find(function(b) {
                                            return b.address == token.address;
                                        })) === null || ref === void 0 ? void 0 : ref.balance;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6FWJQRCB/* Spacer */.L, {
                                                    mt: 1
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenList, {
                                                    token: token,
                                                    balance: balance,
                                                    _onClick: function() {
                                                        selectToken(token);
                                                        onClose();
                                                    }
                                                })
                                            ]
                                        }, i);
                                    }))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./hooks/polkadotExtension/useAccounts.ts + 1 modules
var useAccounts = __webpack_require__(28037);
// EXTERNAL MODULE: ./hooks/token/useNativeToken.ts
var useNativeToken = __webpack_require__(2282);
// EXTERNAL MODULE: ./hooks/token/useTokens.ts
var useTokens = __webpack_require__(78669);
// EXTERNAL MODULE: ./hooks/token/useTokensBalance.ts
var useTokensBalance = __webpack_require__(12255);
// EXTERNAL MODULE: ./hooks/token/useFetchTokenUSDCPrice.ts + 1 modules
var useFetchTokenUSDCPrice = __webpack_require__(72455);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(41050);
// EXTERNAL MODULE: ./hooks/token/useGetWrappedTokenIfNative.ts
var useGetWrappedTokenIfNative = __webpack_require__(88830);
// EXTERNAL MODULE: ./constants/transaction.ts
var transaction = __webpack_require__(74292);
;// CONCATENATED MODULE: ./components/Tokens/SelectToken.tsx














var SelectToken = function(param) {
    var title = param.title, showMax = param.showMax, setNativeTokenAsDefault = param.setNativeTokenAsDefault, inputAmount = param.inputAmount, token = param.token, setInputAmount = param.setInputAmount, setToken = param.setToken, excludeToken = param.excludeToken, transactionState = param.transactionState;
    var ref = (0,chunk_CHB4ZXZG/* useDisclosure */.q)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var account = (0,useAccounts/* useAccounts */.x)().account;
    var nativeToken = (0,useNativeToken/* useNativeToken */.u)();
    var allTokens = (0,useTokens/* useAllTokens */.e)();
    var wrappedExcludeToken = (0,useGetWrappedTokenIfNative/* useGetWrappedTokenIfNative */.q)(excludeToken);
    var tokens = (0,react.useMemo)(function() {
        return allTokens.filter(function(token) {
            return !token.isWrapped;
        }).filter(function(token) {
            return token.address != (excludeToken === null || excludeToken === void 0 ? void 0 : excludeToken.address);
        }).filter(function(token) {
            return token.address != (wrappedExcludeToken === null || wrappedExcludeToken === void 0 ? void 0 : wrappedExcludeToken.address);
        });
    }, [
        allTokens,
        excludeToken === null || excludeToken === void 0 ? void 0 : excludeToken.address,
        wrappedExcludeToken === null || wrappedExcludeToken === void 0 ? void 0 : wrappedExcludeToken.address
    ]);
    var ref1 = (0,useTokensBalance/* useTokensBalance */.h)(tokens || [], account), balances = ref1.balances, refetch = ref1.refetch;
    var USDC = (0,react.useMemo)(function() {
        return tokens.find(function(token) {
            return token.symbol === "USDC";
        });
    }, [
        tokens
    ]);
    var tokenPrice = (0,useFetchTokenUSDCPrice/* useFetchTokenUSDCPrice */.w)(token);
    var tokenValueInUSD = (0,react.useMemo)(function() {
        if (tokenPrice && tokenPrice.price && inputAmount) {
            var isTokenUSDC = (token === null || token === void 0 ? void 0 : token.symbol) === (USDC === null || USDC === void 0 ? void 0 : USDC.symbol);
            return new bignumber/* default */.Z(isTokenUSDC ? "1" : tokenPrice.price).multipliedBy(new bignumber/* default */.Z(inputAmount));
        }
    }, [
        tokenPrice,
        inputAmount,
        token,
        USDC
    ]);
    var balance = (0,react.useMemo)(function() {
        var ref;
        return (ref = balances === null || balances === void 0 ? void 0 : balances.find(function(balance) {
            return balance.address == (token === null || token === void 0 ? void 0 : token.address);
        })) === null || ref === void 0 ? void 0 : ref.balance;
    }, [
        token,
        balances
    ]);
    var fullBalance = (0,react.useMemo)(function() {
        return (0,formatBalance/* getDisplayBalanceAmount */.hr)(balance, token === null || token === void 0 ? void 0 : token.decimal);
    }, [
        balance,
        token
    ]);
    (0,react.useEffect)(function() {
        if (!token && nativeToken && setNativeTokenAsDefault) {
            setToken(nativeToken);
        }
    }, [
        nativeToken,
        setNativeTokenAsDefault,
        token
    ]);
    (0,react.useEffect)(function() {
        if (transactionState && transactionState === transaction/* TransactionState.SUCCESS */.g.SUCCESS) {
            refetch();
        }
    }, [
        refetch,
        transactionState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6CSUKJP7/* Box */.xu, {
                backgroundColor: "blackAlpha.300",
                padding: "12px",
                borderRadius: "8px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_PXXQR4UW/* FormControl */.NI, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_3HLJVDJ7/* FormLabel */.l, {
                                    fontSize: {
                                        base: 14,
                                        lg: 16
                                    },
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6FWJQRCB/* Spacer */.L, {}),
                                showMax && /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_NAA7TEES/* Button */.z, {
                                    size: {
                                        base: "sm",
                                        lg: "md"
                                    },
                                    fontSize: {
                                        base: 14,
                                        lg: 16
                                    },
                                    bg: "blackAlpha.300",
                                    border: "1px",
                                    rounded: "md",
                                    borderColor: "whiteAlpha.500",
                                    onClick: function() {
                                        return setInputAmount(fullBalance);
                                    },
                                    children: "Max"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_7MR544DA/* InputGroup */.B, {
                            mt: "4",
                            mb: "4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectTokenButton, {
                                    token: token,
                                    _onClick: onOpen
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_GIDWA67N/* NumberInput */.Y2, {
                                    width: "100%",
                                    fontSize: {
                                        base: 14,
                                        lg: 16
                                    },
                                    size: {
                                        base: "sm",
                                        lg: "lg"
                                    },
                                    value: inputAmount,
                                    onChange: setInputAmount,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_GIDWA67N/* NumberInputField */.zu, {
                                        border: "0",
                                        placeholder: "0.0",
                                        textAlign: "right"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
                            justify: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_PXXQR4UW/* FormHelperText */.Q6, {
                                    fontSize: {
                                        base: 12,
                                        lg: 16
                                    },
                                    children: [
                                        "Balance: ",
                                        fullBalance
                                    ]
                                }),
                                tokenValueInUSD && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_PXXQR4UW/* FormHelperText */.Q6, {
                                    fontSize: {
                                        base: 12,
                                        lg: 16
                                    },
                                    children: [
                                        "$ ",
                                        tokenValueInUSD.toFixed(2)
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectTokenModal, {
                isOpen: isOpen,
                onClose: onClose,
                selectToken: setToken,
                tokens: tokens,
                balances: balances
            })
        ]
    });
};


/***/ }),

/***/ 5778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ ApprovalState; },
  "q": function() { return /* binding */ useApproveCallback; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(43692);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(61557);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(41050);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./hooks/contract/usePsp22Contract.ts
var usePsp22Contract = __webpack_require__(73075);
// EXTERNAL MODULE: ./hooks/polkadotExtension/useAccounts.ts + 1 modules
var useAccounts = __webpack_require__(28037);
;// CONCATENATED MODULE: ./hooks/token/useTokenAllowance.ts





var useTokenAllowance = function(token, owner, spender) {
    var psp22 = (0,usePsp22Contract/* usePsp22Contract */.N)(token === null || token === void 0 ? void 0 : token.address, null);
    var ref = (0,react.useState)(), allowance = ref[0], setAllowance = ref[1];
    var fetchTokenAllowance = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var value, balance;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!psp22 || !owner || !spender) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        psp22.query.allowance(owner, spender)
                    ];
                case 1:
                    value = _state.sent().value;
                    if (!value.ok) return [
                        2
                    ];
                    balance = new bignumber/* default */.Z(value.ok.toString());
                    setAllowance(balance);
                    return [
                        2
                    ];
            }
        });
    }), [
        owner,
        psp22,
        spender
    ]);
    (0,react.useEffect)(function() {
        fetchTokenAllowance();
    }, [
        psp22,
        owner,
        spender,
        token,
        fetchTokenAllowance
    ]);
    return {
        allowance: allowance,
        fetchTokenAllowance: fetchTokenAllowance
    };
};
/* harmony default export */ var token_useTokenAllowance = ((/* unused pure expression or super */ null && (useTokenAllowance)));

// EXTERNAL MODULE: ./constants/transaction.ts
var transaction = __webpack_require__(74292);
;// CONCATENATED MODULE: ./constants/numbers.ts

var MaxUint256 = new bignumber/* default */.Z("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
var MaxUint128 = new bignumber/* default */.Z("0xffffffffffffffffffffffffffffffff");

// EXTERNAL MODULE: ./utils/token/formatBalance.ts
var formatBalance = __webpack_require__(95487);
// EXTERNAL MODULE: ./utils/env/sentry.ts
var sentry = __webpack_require__(37572);
;// CONCATENATED MODULE: ./hooks/token/useApproveCallback.ts











var ApprovalState;
(function(ApprovalState) {
    ApprovalState[ApprovalState["UNKNOWN"] = 0] = "UNKNOWN";
    ApprovalState[ApprovalState["NOT_APPROVED"] = 1] = "NOT_APPROVED";
    ApprovalState[ApprovalState["APPROVED"] = 2] = "APPROVED";
})(ApprovalState || (ApprovalState = {}));
// returns a variable indicating the state of the approval and a function which approves if necessary or early returns
var useApproveCallback = function(token, amount, spender) {
    var ref = (0,react.useState)(), approveTxnState = ref[0], setApproveTxnState = ref[1];
    var ref1 = (0,react.useState)(), approveResult = ref1[0], setApproveResult = ref1[1];
    var ref2 = (0,react.useState)(""), error = ref2[0], setError = ref2[1];
    var ref3 = (0,useAccounts/* useAccounts */.x)(), account = ref3.account, keyringPair = ref3.keyringPair, signer = ref3.signer;
    var ref4 = useTokenAllowance(token, account === null || account === void 0 ? void 0 : account.address, spender), currentAllowance = ref4.allowance, fetchTokenAllowance = ref4.fetchTokenAllowance;
    var psp22 = (0,usePsp22Contract/* usePsp22Contract */.N)(token === null || token === void 0 ? void 0 : token.address, keyringPair);
    // check the current approval status
    var approvalState = (0,react.useMemo)(function() {
        if (!amount || !spender || !token) return ApprovalState.UNKNOWN;
        // we might not have enough data to know whether or not we need to approve
        if (!currentAllowance) return ApprovalState.UNKNOWN;
        var formattedAmount = (0,bignumber/* default */.Z)((0,formatBalance/* getDisplayDecimalAmount */.jV)(amount, token.decimal));
        // amountToApprove will be defined if currentAllowance is
        return currentAllowance.gte(formattedAmount) && !currentAllowance.isZero() ? ApprovalState.APPROVED : ApprovalState.NOT_APPROVED;
    }, [
        amount,
        currentAllowance,
        spender,
        token
    ]);
    var approve = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var amountToApprove, ref, gasRequired, storageDeposit;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (approvalState !== ApprovalState.NOT_APPROVED) {
                        console.error("approve was called unnecessarily");
                        return [
                            2
                        ];
                    }
                    if (!token) {
                        console.error("no token");
                        return [
                            2
                        ];
                    }
                    if (!spender) {
                        console.error("no spender");
                        return [
                            2
                        ];
                    }
                    if (!psp22) {
                        return [
                            2
                        ];
                    }
                    amountToApprove = MaxUint128;
                    return [
                        4,
                        psp22.query.approve(spender, amountToApprove.toFixed(0))
                    ];
                case 1:
                    ref = _state.sent(), gasRequired = ref.gasRequired, storageDeposit = ref.storageDeposit;
                    setError("");
                    setApproveTxnState(transaction/* TransactionState.WAITING_FOR_CONFIRMATION */.g.WAITING_FOR_CONFIRMATION);
                    return [
                        4,
                        psp22.tx.approve(spender, amountToApprove.toFixed(0), {
                            gasLimit: gasRequired,
                            storageDepositLimit: storageDeposit.asCharge
                        }, {
                            signer: signer === null || signer === void 0 ? void 0 : signer.signer
                        }).then(function(tx) {
                            tx.wait.then(function() {
                                setApproveResult(tx);
                                if (tx.error) {
                                    setError(tx.error.message);
                                    setApproveTxnState(transaction/* TransactionState.ERROR */.g.ERROR);
                                    (0,sentry/* sentryLogError */.P)(tx.error);
                                    return;
                                }
                                setApproveTxnState(transaction/* TransactionState.SUCCESS */.g.SUCCESS);
                            });
                        }).catch(function(e) {
                            var ref;
                            setError((ref = e.error) === null || ref === void 0 ? void 0 : ref.message);
                            setApproveTxnState(transaction/* TransactionState.ERROR */.g.ERROR);
                            (0,sentry/* sentryLogError */.P)(e);
                            console.error("hi error occured", e);
                        })
                    ];
                case 2:
                    _state.sent();
                    fetchTokenAllowance();
                    return [
                        2
                    ];
            }
        });
    }), [
        approvalState,
        token,
        spender,
        psp22,
        signer === null || signer === void 0 ? void 0 : signer.signer,
        fetchTokenAllowance
    ]);
    return [
        approvalState,
        approve,
        approveTxnState,
        approveResult,
        setApproveTxnState,
        error
    ];
};


/***/ }),

/***/ 70767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useFindTokenByAddressOrSymbol; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);
/* harmony import */ var _useTokens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78669);


var useFindTokenByAddressOrSymbol = function(addressOrSymbol) {
    var tokens = (0,_useTokens__WEBPACK_IMPORTED_MODULE_1__/* .useAllTokens */ .e)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        // fetch Token's infor by tokenAddress if it doesn't exsit in constant
        return tokens.find(function(x) {
            return x.address == addressOrSymbol || x.symbol == addressOrSymbol;
        });
    }, [
        addressOrSymbol,
        tokens
    ]);
};


/***/ }),

/***/ 2282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useNativeToken; }
/* harmony export */ });
/* harmony import */ var _useTokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78669);

var useNativeToken = function() {
    var allTokens = (0,_useTokens__WEBPACK_IMPORTED_MODULE_0__/* .useAllTokens */ .e)();
    if (!allTokens) {
        return;
    }
    return allTokens.find(function(token) {
        return token.isNative;
    }) || undefined;
};


/***/ }),

/***/ 64459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useTokenBalance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43692);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21157);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61557);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);
/* harmony import */ var state_blockNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70418);
/* harmony import */ var _utils_token_formatBalance__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95487);
/* harmony import */ var _useApi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1544);
/* harmony import */ var _hooks_polkadotExtension_useAccounts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28037);
/* harmony import */ var _contract_usePsp22Contract__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73075);









var useTokenBalance = function(token) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), balance = ref[0], setBalance = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,state_blockNumber__WEBPACK_IMPORTED_MODULE_1__/* .useBlockNumber */ .O)(), 1), blockNumber = ref1[0];
    var account = (0,_hooks_polkadotExtension_useAccounts__WEBPACK_IMPORTED_MODULE_4__/* .useAccounts */ .x)().account;
    var contract = (0,_contract_usePsp22Contract__WEBPACK_IMPORTED_MODULE_5__/* .usePsp22Contract */ .N)(token === null || token === void 0 ? void 0 : token.address, undefined);
    var api = (0,_useApi__WEBPACK_IMPORTED_MODULE_3__/* .useApi */ .h_)();
    var fetchBalance = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
        var ref, balance, value, balance1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!contract || !api || !account || !token) {
                        return [
                            2
                        ];
                    }
                    if (!token.isNative) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        api.query.system.account(account.address)
                    ];
                case 1:
                    ref = _state.sent(), balance = ref.data;
                    setBalance((0,_utils_token_formatBalance__WEBPACK_IMPORTED_MODULE_2__/* .toBigNumber */ .Ob)(balance.free));
                    return [
                        2
                    ];
                case 2:
                    return [
                        4,
                        contract.query.balanceOf(account.address)
                    ];
                case 3:
                    value = _state.sent().value;
                    if (!value.ok) return [
                        2
                    ];
                    balance1 = value.ok.rawNumber;
                    setBalance((0,_utils_token_formatBalance__WEBPACK_IMPORTED_MODULE_2__/* .toBigNumber */ .Ob)(balance1));
                    return [
                        2
                    ];
            }
        });
    }), [
        account,
        api,
        contract,
        token
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        fetchBalance();
    }, [
        fetchBalance,
        blockNumber
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            balance: balance
        };
    }, [
        balance
    ]);
};


/***/ }),

/***/ 12255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useTokensBalance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43692);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21157);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61557);
/* harmony import */ var _polkadot_api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);
/* harmony import */ var _useApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1544);
/* harmony import */ var _utils_types_contracts_psp22_token__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69253);
/* harmony import */ var _utils_token_formatBalance__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95487);
/* harmony import */ var state_blockNumber__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70418);










var useTokensBalance = function(tokens, account) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), balances = ref[0], setBalances = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,state_blockNumber__WEBPACK_IMPORTED_MODULE_4__/* .useBlockNumber */ .O)(), 1), blockNumber = ref1[0];
    var api = (0,_useApi__WEBPACK_IMPORTED_MODULE_1__/* .useApi */ .h_)();
    var accountAddress = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!account) {
            return;
        }
        if (typeof account === "string") {
            return account;
        } else {
            return account.address;
        }
    }, [
        account
    ]);
    var contracts = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!api) {
            return null;
        }
        if (!tokens || (tokens === null || tokens === void 0 ? void 0 : tokens.length) <= 0) {
            return null;
        }
        var keyring = new _polkadot_api__WEBPACK_IMPORTED_MODULE_6__/* .Keyring */ .Y({
            type: "sr25519"
        });
        var aliceKeyringPair = keyring.addFromUri("//Alice");
        return tokens.map(function(token) {
            return {
                address: token.address,
                contract: new _utils_types_contracts_psp22_token__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(token.address, aliceKeyringPair, api),
                token: token
            };
        });
    }, [
        tokens,
        api
    ]);
    var fetchBalance = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
        var balances, i, _i, address, contract, token, ref, balance, value, balance1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!contracts || !api || !accountAddress) {
                        return [
                            2
                        ];
                    }
                    balances = [];
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < contracts.length)) return [
                        3,
                        6
                    ];
                    _i = contracts[i], address = _i.address, contract = _i.contract, token = _i.token;
                    if (!token.isNative) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        api.query.system.account(accountAddress)
                    ];
                case 2:
                    ref = _state.sent(), balance = ref.data;
                    balances.push({
                        address: address,
                        balance: (0,_utils_token_formatBalance__WEBPACK_IMPORTED_MODULE_3__/* .toBigNumber */ .Ob)(balance.free),
                        token: token
                    });
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        contract.query.balanceOf(accountAddress)
                    ];
                case 4:
                    value = _state.sent().value;
                    balance1 = value.ok.rawNumber;
                    balances.push({
                        address: address,
                        balance: (0,_utils_token_formatBalance__WEBPACK_IMPORTED_MODULE_3__/* .toBigNumber */ .Ob)(balance1),
                        token: token
                    });
                    _state.label = 5;
                case 5:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 6:
                    setBalances(balances);
                    return [
                        2
                    ];
            }
        });
    }), [
        accountAddress,
        api,
        contracts
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        fetchBalance();
    }, [
        fetchBalance,
        blockNumber
    ]);
    return {
        balances: balances,
        refetch: fetchBalance
    };
};


/***/ }),

/***/ 44719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useToBigNumber; }
/* harmony export */ });
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41050);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56168);


var useToBigNumber = function(amount) {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!amount) {
            return new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(0);
        }
        return new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(amount);
    }, [
        amount
    ]);
};


/***/ }),

/***/ 31998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(21157);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./components/Layout/index.tsx + 9 modules
var Layout = __webpack_require__(62667);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75332);
// EXTERNAL MODULE: ./hooks/token/useFindTokenByAddressOrSymbol.ts
var useFindTokenByAddressOrSymbol = __webpack_require__(70767);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5447);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(99728);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-MPFPK3CX.mjs
var chunk_MPFPK3CX = __webpack_require__(88828);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-6CSUKJP7.mjs
var chunk_6CSUKJP7 = __webpack_require__(62824);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-SRMZVY4F.mjs
var chunk_SRMZVY4F = __webpack_require__(23908);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-B2MGPQRJ.mjs
var chunk_B2MGPQRJ = __webpack_require__(65186);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-6FWJQRCB.mjs
var chunk_6FWJQRCB = __webpack_require__(60480);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-O5CRURSQ.mjs + 3 modules
var chunk_O5CRURSQ = __webpack_require__(48069);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chunk-NAA7TEES.mjs + 3 modules
var chunk_NAA7TEES = __webpack_require__(53984);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-YGVX4ESO.mjs
var chunk_YGVX4ESO = __webpack_require__(88977);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./components/Modal/TxnSuccessModal.tsx + 1 modules
var TxnSuccessModal = __webpack_require__(98441);
// EXTERNAL MODULE: ./components/Modal/WaitForConfirmationModal.tsx
var WaitForConfirmationModal = __webpack_require__(56018);
// EXTERNAL MODULE: ./components/Tokens/SelectToken.tsx + 4 modules
var SelectToken = __webpack_require__(47878);
// EXTERNAL MODULE: ./hooks/token/useApproveCallback.ts + 2 modules
var useApproveCallback = __webpack_require__(5778);
;// CONCATENATED MODULE: ./components/Tokens/SwapButton.tsx




var SwapButton = function(param) {
    var token = param.token, approveState = param.approveState, swap = param.swap, approve = param.approve;
    var t = (0,useTranslation/* default */.Z)("common").t;
    if (token.isNative || approveState === useApproveCallback/* ApprovalState.APPROVED */.U.APPROVED) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_NAA7TEES/* Button */.z, {
            fontSize: {
                base: 14,
                lg: 16
            },
            onClick: swap,
            fontWeight: "bold",
            children: t("Swap")
        });
    }
    if (approveState === useApproveCallback/* ApprovalState.NOT_APPROVED */.U.NOT_APPROVED) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_NAA7TEES/* Button */.z, {
            fontSize: {
                base: 14,
                lg: 16
            },
            onClick: approve,
            fontWeight: "bold",
            children: t("Approve ".concat(token.symbol))
        });
    }
    if (approveState === useApproveCallback/* ApprovalState.UNKNOWN */.U.UNKNOWN) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_NAA7TEES/* Button */.z, {
            fontSize: {
                base: 14,
                lg: 16
            },
            isDisabled: true,
            children: "fetching...."
        });
    }
    return null;
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-P74GIWPW.mjs
var chunk_P74GIWPW = __webpack_require__(24156);
// EXTERNAL MODULE: ./components/Tokens/TokenImage.tsx
var TokenImage = __webpack_require__(78732);
// EXTERNAL MODULE: ./hooks/useApi.ts + 247 modules
var useApi = __webpack_require__(1544);
;// CONCATENATED MODULE: ./components/Swap/RoutePath.tsx




var RoutePath = function(param) {
    var routePath = param.routePath;
    var chainId = (0,useApi/* useChainId */.xx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6CSUKJP7/* Box */.xu, {
        borderRadius: "12",
        background: "blackAlpha.300",
        maxWidth: "480px",
        minWidth: {
            base: "100%",
            lg: "480px"
        },
        px: 5,
        py: 3,
        fontSize: {
            base: 12,
            lg: 16
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                    children: "Route"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6FWJQRCB/* Spacer */.L, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_MPFPK3CX/* Flex */.k, {
                    children: routePath === null || routePath === void 0 ? void 0 : routePath.map(function(path, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenImage/* TokenImage */.O, {
                            address: path,
                            ml: 2,
                            boxSize: "20px"
                        }, i);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(27427);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/node_modules/@chakra-ui/icon/dist/chunk-QODHG6BI.mjs + 2 modules
var chunk_QODHG6BI = __webpack_require__(22873);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/icons/dist/chunk-MPWSHGS7.mjs
// src/ArrowDown.tsx

var ArrowDownIcon = (0,chunk_QODHG6BI/* createIcon */.I)({
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z",
  displayName: "ArrowDownIcon"
});



// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chunk-3HSDMH4Y.mjs
var chunk_3HSDMH4Y = __webpack_require__(83948);
;// CONCATENATED MODULE: ./components/Swap/SwitchTokenButton.tsx





var SwitchTokenButton = function(_param) {
    var onHandleClick = _param.onHandleClick, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "onHandleClick"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_3HSDMH4Y/* IconButton */.h, (0,_object_spread/* default */.Z)({
        margin: "-25px",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownIcon, {}),
        pos: "relative",
        bg: "gray.800",
        zIndex: 10,
        _hover: {
            bg: "gray.700"
        },
        width: {
            base: "25px",
            lg: "50px"
        },
        height: {
            base: "38px",
            lg: "50px"
        },
        borderRadius: "50%",
        onClick: onHandleClick
    }, rest));
};

;// CONCATENATED MODULE: ./node_modules/@chakra-ui/icons/dist/chunk-5OU7C5LL.mjs
// src/QuestionOutline.tsx


var QuestionOutlineIcon = (0,chunk_QODHG6BI/* createIcon */.I)({
  displayName: "QuestionOutlineIcon",
  path: /* @__PURE__ */ (0,jsx_runtime.jsxs)("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ (0,jsx_runtime.jsx)(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ (0,jsx_runtime.jsx)(
      "path",
      {
        fill: "none",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ (0,jsx_runtime.jsx)("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] })
});



;// CONCATENATED MODULE: ./node_modules/@chakra-ui/tooltip/dist/chunk-UNJFLZPD.mjs
// src/tooltip.transition.tsx
var scale = {
  exit: {
    scale: 0.85,
    opacity: 0,
    transition: {
      opacity: { duration: 0.15, easings: "easeInOut" },
      scale: { duration: 0.2, easings: "easeInOut" }
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      opacity: { easings: "easeOut", duration: 0.2 },
      scale: { duration: 0.2, ease: [0.175, 0.885, 0.4, 1.1] }
    }
  }
};



// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-event-listener/dist/index.mjs
var dist = __webpack_require__(57818);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-disclosure/dist/index.mjs
var react_use_disclosure_dist = __webpack_require__(95081);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/popper/dist/chunk-HJWVQQGO.mjs + 56 modules
var chunk_HJWVQQGO = __webpack_require__(15241);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/popper/dist/chunk-QAKUNGSB.mjs
var chunk_QAKUNGSB = __webpack_require__(10044);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-merge-refs/dist/index.mjs
var react_use_merge_refs_dist = __webpack_require__(7778);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/shared-utils/dist/index.mjs
var shared_utils_dist = __webpack_require__(63256);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/tooltip/dist/chunk-GOQMVUD7.mjs
// src/use-tooltip.ts






var getDoc = (ref) => {
  var _a;
  return ((_a = ref.current) == null ? void 0 : _a.ownerDocument) || document;
};
var getWin = (ref) => {
  var _a, _b;
  return ((_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) == null ? void 0 : _b.defaultView) || window;
};
function useTooltip(props = {}) {
  const {
    openDelay = 0,
    closeDelay = 0,
    closeOnClick = true,
    closeOnMouseDown,
    closeOnScroll,
    closeOnPointerDown = closeOnMouseDown,
    closeOnEsc = true,
    onOpen: onOpenProp,
    onClose: onCloseProp,
    placement,
    id,
    isOpen: isOpenProp,
    defaultIsOpen,
    arrowSize = 10,
    arrowShadowColor,
    arrowPadding,
    modifiers,
    isDisabled,
    gutter,
    offset,
    direction,
    ...htmlProps
  } = props;
  const { isOpen, onOpen, onClose } = (0,react_use_disclosure_dist/* useDisclosure */.q)({
    isOpen: isOpenProp,
    defaultIsOpen,
    onOpen: onOpenProp,
    onClose: onCloseProp
  });
  const { referenceRef, getPopperProps, getArrowInnerProps, getArrowProps } = (0,chunk_HJWVQQGO/* usePopper */.D)({
    enabled: isOpen,
    placement,
    arrowPadding,
    modifiers,
    gutter,
    offset,
    direction
  });
  const uuid = (0,react.useId)();
  const uid = id != null ? id : uuid;
  const tooltipId = `tooltip-${uid}`;
  const ref = (0,react.useRef)(null);
  const enterTimeout = (0,react.useRef)();
  const clearEnterTimeout = (0,react.useCallback)(() => {
    if (enterTimeout.current) {
      clearTimeout(enterTimeout.current);
      enterTimeout.current = void 0;
    }
  }, []);
  const exitTimeout = (0,react.useRef)();
  const clearExitTimeout = (0,react.useCallback)(() => {
    if (exitTimeout.current) {
      clearTimeout(exitTimeout.current);
      exitTimeout.current = void 0;
    }
  }, []);
  const closeNow = (0,react.useCallback)(() => {
    clearExitTimeout();
    onClose();
  }, [onClose, clearExitTimeout]);
  const dispatchCloseEvent = useCloseEvent(ref, closeNow);
  const openWithDelay = (0,react.useCallback)(() => {
    if (!isDisabled && !enterTimeout.current) {
      dispatchCloseEvent();
      const win = getWin(ref);
      enterTimeout.current = win.setTimeout(onOpen, openDelay);
    }
  }, [dispatchCloseEvent, isDisabled, onOpen, openDelay]);
  const closeWithDelay = (0,react.useCallback)(() => {
    clearEnterTimeout();
    const win = getWin(ref);
    exitTimeout.current = win.setTimeout(closeNow, closeDelay);
  }, [closeDelay, closeNow, clearEnterTimeout]);
  const onClick = (0,react.useCallback)(() => {
    if (isOpen && closeOnClick) {
      closeWithDelay();
    }
  }, [closeOnClick, closeWithDelay, isOpen]);
  const onPointerDown = (0,react.useCallback)(() => {
    if (isOpen && closeOnPointerDown) {
      closeWithDelay();
    }
  }, [closeOnPointerDown, closeWithDelay, isOpen]);
  const onKeyDown = (0,react.useCallback)(
    (event) => {
      if (isOpen && event.key === "Escape") {
        closeWithDelay();
      }
    },
    [isOpen, closeWithDelay]
  );
  (0,dist/* useEventListener */.O)(
    () => getDoc(ref),
    "keydown",
    closeOnEsc ? onKeyDown : void 0
  );
  (0,dist/* useEventListener */.O)(
    () => getDoc(ref),
    "scroll",
    () => {
      if (isOpen && closeOnScroll) {
        closeNow();
      }
    }
  );
  (0,react.useEffect)(() => {
    if (!isDisabled)
      return;
    clearEnterTimeout();
    if (isOpen)
      onClose();
  }, [isDisabled, isOpen, onClose, clearEnterTimeout]);
  (0,react.useEffect)(
    () => () => {
      clearEnterTimeout();
      clearExitTimeout();
    },
    [clearEnterTimeout, clearExitTimeout]
  );
  (0,dist/* useEventListener */.O)(() => ref.current, "pointerleave", closeWithDelay);
  const getTriggerProps = (0,react.useCallback)(
    (props2 = {}, _ref = null) => {
      const triggerProps = {
        ...props2,
        ref: (0,react_use_merge_refs_dist/* mergeRefs */.lq)(ref, _ref, referenceRef),
        onPointerEnter: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onPointerEnter, (e) => {
          if (e.pointerType === "touch")
            return;
          openWithDelay();
        }),
        onClick: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onClick, onClick),
        onPointerDown: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onPointerDown, onPointerDown),
        onFocus: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onFocus, openWithDelay),
        onBlur: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onBlur, closeWithDelay),
        "aria-describedby": isOpen ? tooltipId : void 0
      };
      return triggerProps;
    },
    [
      openWithDelay,
      closeWithDelay,
      onPointerDown,
      isOpen,
      tooltipId,
      onClick,
      referenceRef
    ]
  );
  const getTooltipPositionerProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => getPopperProps(
      {
        ...props2,
        style: {
          ...props2.style,
          [chunk_QAKUNGSB/* cssVars.arrowSize.var */.Dq.arrowSize["var"]]: arrowSize ? `${arrowSize}px` : void 0,
          [chunk_QAKUNGSB/* cssVars.arrowShadowColor.var */.Dq.arrowShadowColor["var"]]: arrowShadowColor
        }
      },
      forwardedRef
    ),
    [getPopperProps, arrowSize, arrowShadowColor]
  );
  const getTooltipProps = (0,react.useCallback)(
    (props2 = {}, ref2 = null) => {
      const styles = {
        ...props2.style,
        position: "relative",
        transformOrigin: chunk_QAKUNGSB/* cssVars.transformOrigin.varRef */.Dq.transformOrigin.varRef
      };
      return {
        ref: ref2,
        ...htmlProps,
        ...props2,
        id: tooltipId,
        role: "tooltip",
        style: styles
      };
    },
    [htmlProps, tooltipId]
  );
  return {
    isOpen,
    show: openWithDelay,
    hide: closeWithDelay,
    getTriggerProps,
    getTooltipProps,
    getTooltipPositionerProps,
    getArrowProps,
    getArrowInnerProps
  };
}
var closeEventName = "chakra-ui:close-tooltip";
function useCloseEvent(ref, close) {
  (0,react.useEffect)(() => {
    const doc = getDoc(ref);
    doc.addEventListener(closeEventName, close);
    return () => doc.removeEventListener(closeEventName, close);
  }, [close, ref]);
  return () => {
    const doc = getDoc(ref);
    const win = getWin(ref);
    doc.dispatchEvent(new win.CustomEvent(closeEventName));
  };
}



// EXTERNAL MODULE: ./node_modules/@chakra-ui/portal/dist/chunk-YLCZP3C4.mjs
var chunk_YLCZP3C4 = __webpack_require__(27100);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-3LE6AY5Q.mjs + 6 modules
var chunk_3LE6AY5Q = __webpack_require__(49961);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-QEVFQ4EU.mjs
var chunk_QEVFQ4EU = __webpack_require__(98186);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-T2VHL7RE.mjs
var chunk_T2VHL7RE = __webpack_require__(94976);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.mjs
var styled_system_dist = __webpack_require__(76143);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-NLMMK76H.mjs
var chunk_NLMMK76H = __webpack_require__(18317);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 182 modules
var motion = __webpack_require__(55070);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(875);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/tooltip/dist/chunk-OMHV467B.mjs



// src/tooltip.tsx




// ../../utilities/object-utils/src/index.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone) {
      delete clone[key];
    }
  }
  return clone;
}
function pick(object, keysToPick) {
  const result = {};
  for (const key of keysToPick) {
    if (key in object) {
      result[key] = object[key];
    }
  }
  return result;
}

// src/tooltip.tsx



var MotionDiv = (0,chunk_3LE6AY5Q/* chakra */.m)(motion/* motion.div */.E.div);
var Tooltip = (0,chunk_QEVFQ4EU/* forwardRef */.G)((props, ref) => {
  var _a, _b;
  const styles = (0,chunk_T2VHL7RE/* useStyleConfig */.mq)("Tooltip", props);
  const ownProps = (0,styled_system_dist/* omitThemingProps */.Lr)(props);
  const theme = (0,chunk_NLMMK76H/* useTheme */.F)();
  const {
    children,
    label,
    shouldWrapChildren,
    "aria-label": ariaLabel,
    hasArrow,
    bg,
    portalProps,
    background,
    backgroundColor,
    bgColor,
    motionProps,
    ...rest
  } = ownProps;
  const userDefinedBg = (_b = (_a = background != null ? background : backgroundColor) != null ? _a : bg) != null ? _b : bgColor;
  if (userDefinedBg) {
    styles.bg = userDefinedBg;
    const bgVar = (0,styled_system_dist/* getCSSVar */.K1)(theme, "colors", userDefinedBg);
    styles[chunk_QAKUNGSB/* cssVars.arrowBg.var */.Dq.arrowBg["var"]] = bgVar;
  }
  const tooltip = useTooltip({ ...rest, direction: theme.direction });
  const shouldWrap = typeof children === "string" || shouldWrapChildren;
  let trigger;
  if (shouldWrap) {
    trigger = /* @__PURE__ */ (0,jsx_runtime.jsx)(
      chunk_3LE6AY5Q/* chakra.span */.m.span,
      {
        display: "inline-block",
        tabIndex: 0,
        ...tooltip.getTriggerProps(),
        children
      }
    );
  } else {
    const child = react.Children.only(children);
    trigger = (0,react.cloneElement)(
      child,
      tooltip.getTriggerProps(child.props, child.ref)
    );
  }
  const hasAriaLabel = !!ariaLabel;
  const _tooltipProps = tooltip.getTooltipProps({}, ref);
  const tooltipProps = hasAriaLabel ? omit(_tooltipProps, ["role", "id"]) : _tooltipProps;
  const srOnlyProps = pick(_tooltipProps, ["role", "id"]);
  if (!label) {
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children });
  }
  return /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [
    trigger,
    /* @__PURE__ */ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, { children: tooltip.isOpen && /* @__PURE__ */ (0,jsx_runtime.jsx)(chunk_YLCZP3C4/* Portal */.h, { ...portalProps, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
      chunk_3LE6AY5Q/* chakra.div */.m.div,
      {
        ...tooltip.getTooltipPositionerProps(),
        __css: {
          zIndex: styles.zIndex,
          pointerEvents: "none"
        },
        children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(
          MotionDiv,
          {
            variants: scale,
            initial: "exit",
            animate: "enter",
            exit: "exit",
            ...motionProps,
            ...tooltipProps,
            __css: styles,
            children: [
              label,
              hasAriaLabel && /* @__PURE__ */ (0,jsx_runtime.jsx)(chunk_3LE6AY5Q/* chakra.span */.m.span, { srOnly: true, ...srOnlyProps, children: ariaLabel }),
              hasArrow && /* @__PURE__ */ (0,jsx_runtime.jsx)(
                chunk_3LE6AY5Q/* chakra.div */.m.div,
                {
                  "data-popper-arrow": true,
                  className: "chakra-tooltip__arrow-wrapper",
                  children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
                    chunk_3LE6AY5Q/* chakra.div */.m.div,
                    {
                      "data-popper-arrow-inner": true,
                      className: "chakra-tooltip__arrow",
                      __css: { bg: styles.bg }
                    }
                  )
                }
              )
            ]
          }
        )
      }
    ) }) })
  ] });
});
Tooltip.displayName = "Tooltip";



;// CONCATENATED MODULE: ./components/Common/ToolTip.tsx




var ToolTip = function(param) {
    var text = param.text, _ml = param.ml, ml = _ml === void 0 ? 2 : _ml;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
        label: text,
        "aria-label": text,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionOutlineIcon, {
            ml: ml
        })
    });
};

;// CONCATENATED MODULE: ./constants/liquidityProviderFee.ts
var LIQUIDITY_PROVIDER_FEE = 0.003 // 0.3%
;

;// CONCATENATED MODULE: ./utils/swap/computeLiquidityProviderFee.ts

var computeLiquidityProviderFee = function(hop) {
    var fee = LIQUIDITY_PROVIDER_FEE;
    if (hop && hop > 2) {
        fee = 1 - Math.pow(1 - LIQUIDITY_PROVIDER_FEE, hop - 1);
    }
    return fee;
};

;// CONCATENATED MODULE: ./hooks/router/useLiquidityProviderFee.ts

var useLiquidityProviderFee = function(amountIn, hop) {
    var lpFee = computeLiquidityProviderFee(hop);
    return amountIn === null || amountIn === void 0 ? void 0 : amountIn.multipliedBy(lpFee);
};

// EXTERNAL MODULE: ./constants/tradeType.ts
var constants_tradeType = __webpack_require__(36819);
;// CONCATENATED MODULE: ./components/Swap/Details.tsx






var Details = function(param) {
    var minimumAmountReceived = param.minimumAmountReceived, maxAmountSold = param.maxAmountSold, outToken = param.outToken, inToken = param.inToken, amountIn = param.amountIn, hop = param.hop, priceImpact = param.priceImpact, tradeType = param.tradeType;
    var fee = useLiquidityProviderFee(amountIn, hop);
    var priceImpactColor = (0,react.useMemo)(function() {
        if (priceImpact.lte(2)) {
            return "green";
        }
        if (priceImpact.lte(5)) {
            return "yellow";
        }
        return "red";
    }, [
        priceImpact
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_6CSUKJP7/* Box */.xu, {
        borderRadius: "12",
        background: "blackAlpha.300",
        maxWidth: "480px",
        minWidth: {
            base: "100%",
            lg: "480px"
        },
        px: 5,
        py: 3,
        fontSize: {
            base: 12,
            lg: 16
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
                children: [
                    tradeType == constants_tradeType/* TradeType.EXACT_INPUT */.Y.EXACT_INPUT && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                children: [
                                    "Minimum Received",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip, {
                                        text: "Your transaction will revert if there is a large, unfavorable price movement before it is confirmed. "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6FWJQRCB/* Spacer */.L, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
                                children: [
                                    minimumAmountReceived,
                                    " ",
                                    outToken.symbol
                                ]
                            })
                        ]
                    }),
                    tradeType == constants_tradeType/* TradeType.EXACT_OUTPUT */.Y.EXACT_OUTPUT && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                children: [
                                    "Maximum sold",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip, {
                                        text: "Your transaction will revert if there is a large, unfavorable price movement before it is confirmed."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6FWJQRCB/* Spacer */.L, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
                                children: [
                                    maxAmountSold,
                                    " ",
                                    inToken.symbol
                                ]
                            })
                        ]
                    })
                ]
            }),
            priceImpact && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
                mt: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                        children: [
                            "Price Impact",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip, {
                                text: "The difference between the market price and estimated price due to trade size"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6FWJQRCB/* Spacer */.L, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_MPFPK3CX/* Flex */.k, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                            color: priceImpactColor,
                            children: [
                                priceImpact.lte(0.01) ? "0.01<" : priceImpact.toFixed(3),
                                " %"
                            ]
                        })
                    })
                ]
            }),
            fee && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
                mt: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                        children: [
                            "Liquidity Provider Fee",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip, {
                                text: "For each trade a 0.3 goes to liquidity providers and 0.05% goes to the eAPLO staking pool."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6FWJQRCB/* Spacer */.L, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
                        children: [
                            fee.toFixed(5),
                            " ",
                            inToken.symbol
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/@chakra-ui/icons/dist/chunk-JCRXQL3M.mjs
// src/Settings.tsx

var SettingsIcon = (0,chunk_QODHG6BI/* createIcon */.I)({
  viewBox: "0 0 14 14",
  d: "M14,7.77 L14,6.17 L12.06,5.53 L11.61,4.44 L12.49,2.6 L11.36,1.47 L9.55,2.38 L8.46,1.93 L7.77,0.01 L6.17,0.01 L5.54,1.95 L4.43,2.4 L2.59,1.52 L1.46,2.65 L2.37,4.46 L1.92,5.55 L0,6.23 L0,7.82 L1.94,8.46 L2.39,9.55 L1.51,11.39 L2.64,12.52 L4.45,11.61 L5.54,12.06 L6.23,13.98 L7.82,13.98 L8.45,12.04 L9.56,11.59 L11.4,12.47 L12.53,11.34 L11.61,9.53 L12.08,8.44 L14,7.75 L14,7.77 Z M7,10 C5.34,10 4,8.66 4,7 C4,5.34 5.34,4 7,4 C8.66,4 10,5.34 10,7 C10,8.66 8.66,10 7,10 Z",
  displayName: "SettingsIcon"
});



// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/chunk-CHB4ZXZG.mjs + 5 modules
var chunk_CHB4ZXZG = __webpack_require__(44853);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-UUGUEMMH.mjs + 2 modules
var chunk_UUGUEMMH = __webpack_require__(70070);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-OWW5MU75.mjs + 1 modules
var chunk_OWW5MU75 = __webpack_require__(74454);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-66WFFNY3.mjs + 3 modules
var chunk_66WFFNY3 = __webpack_require__(45180);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-YLPWWAYV.mjs
var chunk_YLPWWAYV = __webpack_require__(59172);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-PVJ72NKC.mjs
var chunk_PVJ72NKC = __webpack_require__(46206);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-MUMUYFOI.mjs
var chunk_MUMUYFOI = __webpack_require__(96138);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chunk-DGWZA2DU.mjs
var chunk_DGWZA2DU = __webpack_require__(26581);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/button/dist/chunk-PEYICJIL.mjs


// src/button-group.tsx




var attachedStyles = {
  horizontal: {
    "> *:first-of-type:not(:last-of-type)": { borderEndRadius: 0 },
    "> *:not(:first-of-type):not(:last-of-type)": { borderRadius: 0 },
    "> *:not(:first-of-type):last-of-type": { borderStartRadius: 0 }
  },
  vertical: {
    "> *:first-of-type:not(:last-of-type)": { borderBottomRadius: 0 },
    "> *:not(:first-of-type):not(:last-of-type)": { borderRadius: 0 },
    "> *:not(:first-of-type):last-of-type": { borderTopRadius: 0 }
  }
};
var gapStyles = {
  horizontal: (spacing) => ({
    "& > *:not(style) ~ *:not(style)": { marginStart: spacing }
  }),
  vertical: (spacing) => ({
    "& > *:not(style) ~ *:not(style)": { marginTop: spacing }
  })
};
var ButtonGroup = (0,chunk_QEVFQ4EU/* forwardRef */.G)(
  function ButtonGroup2(props, ref) {
    const {
      size,
      colorScheme,
      variant,
      className,
      spacing = "0.5rem",
      isAttached,
      isDisabled,
      orientation = "horizontal",
      ...rest
    } = props;
    const _className = (0,shared_utils_dist.cx)("chakra-button__group", className);
    const context = (0,react.useMemo)(
      () => ({ size, colorScheme, variant, isDisabled }),
      [size, colorScheme, variant, isDisabled]
    );
    let groupStyles = {
      display: "inline-flex",
      ...isAttached ? attachedStyles[orientation] : gapStyles[orientation](spacing)
    };
    const isVertical = orientation === "vertical";
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(chunk_DGWZA2DU/* ButtonGroupProvider */.D, { value: context, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
      chunk_3LE6AY5Q/* chakra.div */.m.div,
      {
        ref,
        role: "group",
        __css: groupStyles,
        className: _className,
        "data-attached": isAttached ? "" : void 0,
        "data-orientation": orientation,
        flexDir: isVertical ? "column" : void 0,
        ...rest
      }
    ) });
  }
);
ButtonGroup.displayName = "ButtonGroup";



// EXTERNAL MODULE: ./node_modules/@chakra-ui/number-input/dist/chunk-GIDWA67N.mjs + 6 modules
var chunk_GIDWA67N = __webpack_require__(41325);
;// CONCATENATED MODULE: ./components/SwapSetting/SlippageButton.tsx


var SlippageButton = function(param) {
    var _onClick = param._onClick, slippage = param.slippage, val = param.val;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_NAA7TEES/* Button */.z, {
        _hover: {
            bg: "gray.600"
        },
        _active: {
            bg: "gray.600"
        },
        variant: "ghost",
        onClick: function() {
            _onClick(val);
        },
        isActive: slippage == val,
        size: {
            base: "sm",
            lg: "lg"
        },
        fontWeight: "bold",
        children: [
            val,
            "%"
        ]
    });
};

// EXTERNAL MODULE: ./state/slippage.ts
var state_slippage = __webpack_require__(99564);
;// CONCATENATED MODULE: ./components/SwapSetting/SlippageToleranceSetting.tsx






var SlippageToleranceSetting = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,state_slippage/* useSlippage */.k)(), 2), defaultValue = ref[0], setSlippageGlobal = ref[1];
    var ref1 = (0,react.useState)(), isInvalid = ref1[0], setIsInvalid = ref1[1];
    var ref2 = (0,react.useState)((defaultValue * 100).toString()), slippage = ref2[0], setSlippageInput = ref2[1];
    var handleChange = function(value) {
        setIsInvalid(false);
        setSlippageInput(value);
        if (value) {
            setSlippageGlobal(parseFloat(value) / 100);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                mt: 3,
                fontSize: {
                    base: 12,
                    lg: 14
                },
                children: "Slippage Tolerance"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_O5CRURSQ/* Stack */.K, {
                direction: "row",
                align: "center",
                mt: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup, {
                        maxW: "60%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlippageButton, {
                                _onClick: handleChange,
                                val: "0.1",
                                slippage: slippage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlippageButton, {
                                _onClick: handleChange,
                                val: "0.5",
                                slippage: slippage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlippageButton, {
                                _onClick: handleChange,
                                val: "1",
                                slippage: slippage
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_GIDWA67N/* NumberInput */.Y2, {
                        maxW: {
                            base: "60px",
                            lg: "100px"
                        },
                        mr: {
                            base: "1rem",
                            lg: "2rem"
                        },
                        value: slippage,
                        onChange: handleChange,
                        max: 50,
                        min: 0.1,
                        variant: "ghost",
                        size: {
                            base: "sm",
                            lg: "lg"
                        },
                        fontWeight: "bold",
                        onInvalid: function() {
                            return setIsInvalid(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_GIDWA67N/* NumberInputField */.zu, {
                            fontSize: {
                                base: 14,
                                lg: 16
                            },
                            bg: "gray.700"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                        mt: 2,
                        children: "%"
                    })
                ]
            }),
            isInvalid && /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                mt: 2,
                color: "red.400",
                fontSize: {
                    base: 12,
                    lg: 16
                },
                children: "Slippage Tolerance be 0.1 ~ 50%"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(43795);
// EXTERNAL MODULE: ./state/localStorageEffect.ts
var localStorageEffect = __webpack_require__(10220);
;// CONCATENATED MODULE: ./state/transactionDeadline.ts



var DEFAULT_DEADLINE = 20;
var currentTransactionDeadline = (0,es/* atom */.cn)({
    key: "currentTransactionDeadline",
    default: DEFAULT_DEADLINE,
    effects: [
        (0,localStorageEffect/* localStorageEffect */.N)("currentTransactionDeadline")
    ]
});
var useTransactionDeadline = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,es/* useRecoilState */.FV)(currentTransactionDeadline), 2), deadline = ref[0], setDeadline = ref[1];
    return [
        deadline,
        setDeadline
    ];
};

;// CONCATENATED MODULE: ./components/SwapSetting/TransactionDeadlineSetting.tsx





var TransactionDeadlineSetting = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(useTransactionDeadline(), 2), deadline = ref[0], setDeadline = ref[1];
    var ref1 = (0,react.useState)(), isInvalid = ref1[0], setIsInvalid = ref1[1];
    var ref2 = (0,react.useState)(deadline.toString()), _deadline = ref2[0], setDeadlineText = ref2[1];
    var handleChange = function(value) {
        setIsInvalid(false);
        setDeadlineText(value);
        if (value) {
            setDeadline(parseInt(value));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                mt: 3,
                fontSize: {
                    base: 12,
                    lg: 16
                },
                children: "Transaction Deadline"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_O5CRURSQ/* Stack */.K, {
                direction: "row",
                align: "center",
                mt: 3,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_GIDWA67N/* NumberInput */.Y2, {
                        maxW: "100px",
                        mr: "2rem",
                        value: _deadline,
                        onChange: handleChange,
                        max: 50,
                        min: 10,
                        variant: "ghost",
                        size: {
                            base: "sm",
                            lg: "lg"
                        },
                        fontWeight: "bold",
                        onInvalid: function() {
                            return setIsInvalid(true);
                        },
                        errorBorderColor: "red.400",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_GIDWA67N/* NumberInputField */.zu, {
                            bg: "gray.700"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                        mt: 2,
                        fontSize: {
                            base: 12,
                            lg: 16
                        },
                        children: "Minutes"
                    })
                ]
            }),
            isInvalid && /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                mt: 2,
                color: "red.400",
                children: "Minutes must be 10 ~ 50min"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SwapSetting/SettingModal.tsx




var SwapSettingModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_UUGUEMMH/* Modal */.u_, {
            isOpen: isOpen,
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_OWW5MU75/* ModalOverlay */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_66WFFNY3/* ModalContent */.h, {
                    bg: "gray.800",
                    maxW: {
                        base: 320,
                        lg: 480
                    },
                    mx: {
                        base: 2,
                        lg: "inherit"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_YLPWWAYV/* ModalCloseButton */.o, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_PVJ72NKC/* ModalBody */.f, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_MUMUYFOI/* VStack */.g, {
                                m: {
                                    base: 1,
                                    lg: 5
                                },
                                mx: 0,
                                align: "left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_PVJ72NKC/* ModalBody */.f, {
                                    fontSize: {
                                        base: 14,
                                        lg: 16
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_B2MGPQRJ/* Heading */.X, {
                                            as: "h2",
                                            fontSize: {
                                                base: 16,
                                                lg: 20
                                            },
                                            children: "Settings"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SlippageToleranceSetting, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionDeadlineSetting, {})
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/SwapSetting/SettingIcon.tsx




var SwapSettingIcon = function() {
    var ref = (0,chunk_CHB4ZXZG/* useDisclosure */.q)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_3HSDMH4Y/* IconButton */.h, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsIcon, {}),
                "aria-label": "Settings",
                onClick: onOpen,
                variant: "ghost"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapSettingModal, {
                isOpen: isOpen,
                onClose: onClose
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SwapSetting/SlippageTolerance.tsx





var SlippageTolerance = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,state_slippage/* useSlippage */.k)(), 1), slippage = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
        fontSize: {
            base: 12,
            lg: 14
        },
        children: [
            "Slippage Tolerance: ",
            (slippage * 100).toFixed(2),
            "%"
        ]
    });
};

;// CONCATENATED MODULE: ./components/SwapSetting/index.tsx





// EXTERNAL MODULE: ./hooks/graph/useBestTrade.ts + 5 modules
var useBestTrade = __webpack_require__(4393);
// EXTERNAL MODULE: ./hooks/graph/useBuildGraph.ts + 5 modules
var useBuildGraph = __webpack_require__(61033);
// EXTERNAL MODULE: ./hooks/router/useIdealPriceOfTokenIn.ts + 1 modules
var useIdealPriceOfTokenIn = __webpack_require__(68574);
;// CONCATENATED MODULE: ./hooks/router/usePriceImpact.ts



var usePriceImpact = function(param) {
    var bestTradingPath = param.bestTradingPath, inputAmount = param.inputAmount, amountOut = param.amountOut, tokenIn = param.tokenIn, tokenOut = param.tokenOut;
    var idealPrice = (0,useIdealPriceOfTokenIn/* useIdealPriceOfTokenIn */.V)(bestTradingPath, tokenIn, tokenOut);
    var lpFee = computeLiquidityProviderFee(bestTradingPath === null || bestTradingPath === void 0 ? void 0 : bestTradingPath.length);
    return (0,react.useMemo)(function() {
        var ref, ref1;
        // priceImpact = (idealAmountOut - actualAmountOut) / idealAmountOut - lpFee
        if (!amountOut || !inputAmount) {
            return;
        }
        var idealAmountOut = idealPrice === null || idealPrice === void 0 ? void 0 : idealPrice.multipliedBy(inputAmount);
        var deltaAmountOut = (ref = idealAmountOut === null || idealAmountOut === void 0 ? void 0 : idealAmountOut.minus(amountOut)) === null || ref === void 0 ? void 0 : ref.div(idealAmountOut);
        var priceImpact = (ref1 = deltaAmountOut === null || deltaAmountOut === void 0 ? void 0 : deltaAmountOut.minus(lpFee)) === null || ref1 === void 0 ? void 0 : ref1.multipliedBy(100);
        return priceImpact;
    }, [
        amountOut,
        inputAmount,
        idealPrice,
        lpFee
    ]);
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(43692);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(61557);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/chunk-JFERWNZE.mjs
var chunk_JFERWNZE = __webpack_require__(17323);
// EXTERNAL MODULE: ./hooks/contract/useRouterContract.ts + 9 modules
var useRouterContract = __webpack_require__(30376);
// EXTERNAL MODULE: ./hooks/polkadotExtension/useAccounts.ts + 1 modules
var useAccounts = __webpack_require__(28037);
// EXTERNAL MODULE: ./hooks/token/useGetWrappedTokenIfNative.ts
var useGetWrappedTokenIfNative = __webpack_require__(88830);
// EXTERNAL MODULE: ./utils/token/formatBalance.ts
var formatBalance = __webpack_require__(95487);
// EXTERNAL MODULE: ./constants/transaction.ts
var transaction = __webpack_require__(74292);
// EXTERNAL MODULE: ./utils/env/sentry.ts
var sentry = __webpack_require__(37572);
;// CONCATENATED MODULE: ./hooks/router/useSwap.ts













var unixTime = function() {
    return Math.floor(Date.now());
};
var computeDeadlineFromNow = function(deadline) {
    var currentTime = unixTime();
    var DEADLINE_MIN = deadline * 60 * 1000;
    return currentTime + DEADLINE_MIN;
};
var swapExactTokensForTokens = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var tokenA, tokenB, amountIn, amountOut, signer, router, account, routePath, transactionDeadline, queryErrorCb, ref, deadline, ref1, ref2, value, gasRequired, storageDeposit, ref3, error, tx, swapFunctionName, ref4, value1, gasRequired1, storageDeposit1, ref5, error1, tx1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    tokenA = param.tokenA, tokenB = param.tokenB, amountIn = param.amountIn, amountOut = param.amountOut, signer = param.signer, router = param.router, account = param.account, routePath = param.routePath, transactionDeadline = param.transactionDeadline, queryErrorCb = param.queryErrorCb;
                    deadline = computeDeadlineFromNow(transactionDeadline);
                    if (!tokenA.isWrapped) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        router.query.swapExactNativeForTokens((0,formatBalance/* getDisplayDecimalAmount */.jV)(amountOut, tokenB.decimal), routePath, account.address, deadline, {
                            value: (0,formatBalance/* getDisplayDecimalAmount */.jV)(amountIn, tokenA.decimal)
                        })
                    ];
                case 1:
                    ref2 = _state.sent(), value = ref2.value, gasRequired = ref2.gasRequired, storageDeposit = ref2.storageDeposit;
                    if ((ref1 = value.ok) === null || ref1 === void 0 ? void 0 : ref1.err) {
                        ;
                        error = Object.keys((ref3 = value.ok) === null || ref3 === void 0 ? void 0 : ref3.err)[0];
                        queryErrorCb(error);
                        (0,sentry/* sentryLogError */.P)(error);
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        router.tx.swapExactNativeForTokens((0,formatBalance/* getDisplayDecimalAmount */.jV)(amountOut, tokenB.decimal), routePath, account.address, deadline, {
                            value: (0,formatBalance/* getDisplayDecimalAmount */.jV)(amountIn, tokenA.decimal),
                            gasLimit: gasRequired,
                            storageDepositLimit: storageDeposit.asCharge
                        }, {
                            signer: signer.signer
                        })
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        2,
                        tx
                    ];
                case 3:
                    // tokens -> Eth Swap: tokenA (psp22) and tokenB (native)
                    if (tokenB.isWrapped) {
                        swapFunctionName = "swapExactTokensForNative";
                    } else {
                        // tokens -> tokens swap: tokenA (psp22) and tokenB (psp22)
                        swapFunctionName = "swapExactTokensForTokens";
                    }
                    if (!swapFunctionName) {
                        throw "NO SWAP FUNCTION IS FOUND";
                    }
                    return [
                        4,
                        router.query[swapFunctionName]((0,formatBalance/* getDisplayDecimalAmount */.jV)(amountIn, tokenA.decimal), (0,formatBalance/* getDisplayDecimalAmount */.jV)(amountOut, tokenB.decimal), routePath, account.address, deadline)
                    ];
                case 4:
                    ref4 = _state.sent(), value1 = ref4.value, gasRequired1 = ref4.gasRequired, storageDeposit1 = ref4.storageDeposit;
                    if ((ref = value1.ok) === null || ref === void 0 ? void 0 : ref.err) {
                        ;
                        error1 = Object.keys((ref5 = value1.ok) === null || ref5 === void 0 ? void 0 : ref5.err)[0];
                        queryErrorCb(error1);
                        (0,sentry/* sentryLogError */.P)(error1);
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        router.tx[swapFunctionName]((0,formatBalance/* getDisplayDecimalAmount */.jV)(amountIn, tokenA.decimal), (0,formatBalance/* getDisplayDecimalAmount */.jV)(amountOut, tokenB.decimal), routePath, account.address, deadline, {
                            gasLimit: gasRequired1,
                            storageDepositLimit: storageDeposit1.asCharge
                        }, {
                            signer: signer.signer
                        })
                    ];
                case 5:
                    tx1 = _state.sent();
                    return [
                        2,
                        tx1
                    ];
            }
        });
    });
    return function swapExactTokensForTokens(_) {
        return _ref.apply(this, arguments);
    };
}();
var swapTokensForExactTokens = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var tokenA, tokenB, amountIn, amountOut, signer, router, account, routePath, transactionDeadline, deadline, ref, value, gasRequired, storageDeposit, tx, swapFunctionName, ref1, value1, gasRequired1, storageDeposit1, tx1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    tokenA = param.tokenA, tokenB = param.tokenB, amountIn = param.amountIn, amountOut = param.amountOut, signer = param.signer, router = param.router, account = param.account, routePath = param.routePath, transactionDeadline = param.transactionDeadline;
                    deadline = computeDeadlineFromNow(transactionDeadline);
                    if (!tokenA.isWrapped) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        router.query.swapNativeForExactTokens((0,formatBalance/* getDisplayDecimalAmount */.jV)(amountOut, tokenB.decimal), routePath, account.address, deadline, {
                            value: (0,formatBalance/* getDisplayDecimalAmount */.jV)(amountIn, tokenA.decimal)
                        })
                    ];
                case 1:
                    ref = _state.sent(), value = ref.value, gasRequired = ref.gasRequired, storageDeposit = ref.storageDeposit;
                    return [
                        4,
                        router.tx.swapNativeForExactTokens((0,formatBalance/* getDisplayDecimalAmount */.jV)(amountOut, tokenB.decimal), routePath, account.address, deadline, {
                            value: (0,formatBalance/* getDisplayDecimalAmount */.jV)(amountIn, tokenA.decimal),
                            gasLimit: gasRequired,
                            storageDepositLimit: storageDeposit.asCharge
                        }, {
                            signer: signer.signer
                        })
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        2,
                        tx
                    ];
                case 3:
                    // tokens -> Eth Swap: tokenA (psp22) and tokenB (native)
                    if (tokenB.isWrapped) {
                        swapFunctionName = "swapTokensForExactNative";
                    } else {
                        // tokens -> tokens swap: tokenA (psp22) and tokenB (psp22)
                        swapFunctionName = "swapTokensForExactTokens";
                    }
                    if (!swapFunctionName) {
                        throw "NO SWAP FUNCTION IS FOUND";
                    }
                    return [
                        4,
                        router.query[swapFunctionName]((0,formatBalance/* getDisplayDecimalAmount */.jV)(amountIn, tokenA.decimal), (0,formatBalance/* getDisplayDecimalAmount */.jV)(amountOut, tokenB.decimal), routePath, account.address, deadline)
                    ];
                case 4:
                    ref1 = _state.sent(), value1 = ref1.value, gasRequired1 = ref1.gasRequired, storageDeposit1 = ref1.storageDeposit;
                    return [
                        4,
                        router.tx[swapFunctionName]((0,formatBalance/* getDisplayDecimalAmount */.jV)(amountIn, tokenA.decimal), (0,formatBalance/* getDisplayDecimalAmount */.jV)(amountOut, tokenB.decimal), routePath, account.address, deadline, {
                            gasLimit: gasRequired1,
                            storageDepositLimit: storageDeposit1.asCharge
                        }, {
                            signer: signer.signer
                        })
                    ];
                case 5:
                    tx1 = _state.sent();
                    return [
                        2,
                        tx1
                    ];
            }
        });
    });
    return function swapTokensForExactTokens(_) {
        return _ref.apply(this, arguments);
    };
}();
var useSwap = function(tokenA, tokenB, inputAmount, outputAmount, routePath, tradeType) {
    var tokenAorWrapped = (0,useGetWrappedTokenIfNative/* useGetWrappedTokenIfNative */.q)(tokenA);
    var tokenBorWrapped = (0,useGetWrappedTokenIfNative/* useGetWrappedTokenIfNative */.q)(tokenB);
    var ref = (0,_sliced_to_array/* default */.Z)(useTransactionDeadline(), 1), transactionDeadline = ref[0];
    var ref1 = (0,react.useState)(), swapState = ref1[0], setSwapState = ref1[1];
    var ref2 = (0,react.useState)(), txResult = ref2[0], setTxResult = ref2[1];
    var ref3 = (0,react.useState)(""), error = ref3[0], setError = ref3[1];
    var ref4 = (0,useAccounts/* useAccounts */.x)(), account = ref4.account, signer = ref4.signer;
    var router = (0,useRouterContract/* useRouterContract */.T)();
    var toast = (0,chunk_JFERWNZE/* useToast */.p)();
    var queryErrorCb = (0,react.useCallback)(function(error) {
        setSwapState(transaction/* TransactionState.ERROR */.g.ERROR);
        setError(error);
    }, []);
    var swap = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!tokenAorWrapped || !tokenBorWrapped || !inputAmount || !outputAmount || !router || !signer || !routePath || !account) {
                            return [
                                2,
                                null
                            ];
                        }
                        setError("");
                        setSwapState(transaction/* TransactionState.WAITING_FOR_CONFIRMATION */.g.WAITING_FOR_CONFIRMATION);
                        switch(tradeType){
                            case constants_tradeType/* TradeType.EXACT_INPUT */.Y.EXACT_INPUT:
                                return [
                                    3,
                                    1
                                ];
                            case constants_tradeType/* TradeType.EXACT_OUTPUT */.Y.EXACT_OUTPUT:
                                return [
                                    3,
                                    3
                                ];
                        }
                        return [
                            3,
                            5
                        ];
                    case 1:
                        return [
                            4,
                            swapExactTokensForTokens({
                                tokenA: tokenAorWrapped,
                                tokenB: tokenBorWrapped,
                                amountIn: inputAmount,
                                amountOut: outputAmount,
                                router: router,
                                signer: signer,
                                account: account,
                                routePath: routePath,
                                transactionDeadline: transactionDeadline,
                                queryErrorCb: queryErrorCb
                            }).then(function(tx) {
                                if (!tx) {
                                    return;
                                }
                                tx.wait.then(function() {
                                    setTxResult(tx);
                                    if (tx.error) {
                                        setError(tx.error.message);
                                        setSwapState(transaction/* TransactionState.ERROR */.g.ERROR);
                                        toast({
                                            title: "Swap failed",
                                            description: error,
                                            status: "error",
                                            duration: 5000,
                                            isClosable: true
                                        });
                                        (0,sentry/* sentryLogError */.P)(tx.error);
                                        return;
                                    }
                                    setSwapState(transaction/* TransactionState.SUCCESS */.g.SUCCESS);
                                });
                            }).catch(function(e) {
                                var ref;
                                setError((ref = e.error) === null || ref === void 0 ? void 0 : ref.message);
                                setSwapState(transaction/* TransactionState.ERROR */.g.ERROR);
                                toast({
                                    title: "Swap failed",
                                    description: e.message,
                                    status: "error",
                                    duration: 5000,
                                    isClosable: true
                                });
                                (0,sentry/* sentryLogError */.P)(e);
                                console.error("hi error occured", e);
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            swapTokensForExactTokens({
                                tokenA: tokenAorWrapped,
                                tokenB: tokenBorWrapped,
                                amountIn: inputAmount,
                                amountOut: outputAmount,
                                router: router,
                                signer: signer,
                                account: account,
                                routePath: routePath,
                                transactionDeadline: transactionDeadline,
                                queryErrorCb: queryErrorCb
                            }).then(function(tx) {
                                tx.wait.then(function() {
                                    setTxResult(tx);
                                    if (tx.error) {
                                        setError(tx.error.message);
                                        setSwapState(transaction/* TransactionState.ERROR */.g.ERROR);
                                        (0,sentry/* sentryLogError */.P)(tx.error);
                                        return;
                                    }
                                    setSwapState(transaction/* TransactionState.SUCCESS */.g.SUCCESS);
                                });
                            }).catch(function(e) {
                                var ref;
                                setError((ref = e.error) === null || ref === void 0 ? void 0 : ref.message);
                                setSwapState(transaction/* TransactionState.ERROR */.g.ERROR);
                                (0,sentry/* sentryLogError */.P)(e);
                                console.error("hi error occured", e);
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function swap() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        swapState: swapState,
        txResult: txResult,
        setSwapState: setSwapState,
        swap: swap,
        error: error
    };
};

// EXTERNAL MODULE: ./hooks/utils/useToBigNumber.ts
var useToBigNumber = __webpack_require__(44719);
// EXTERNAL MODULE: ./hooks/token/useTokenBalance.ts
var useTokenBalance = __webpack_require__(64459);
// EXTERNAL MODULE: ./components/Modal/TxnErrorModal.tsx
var TxnErrorModal = __webpack_require__(52878);
;// CONCATENATED MODULE: ./components/Swap/index.tsx



























var Swap = function(param) {
    var token = param.token, quotedToken = param.quotedToken;
    var ref, ref1;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var graph = (0,useBuildGraph/* useBuildGraph */.v)();
    var ref2 = (0,react.useState)({
        token: undefined,
        amount: ""
    }), tokenA = ref2[0], setTokenA = ref2[1];
    var ref3 = (0,react.useState)({
        token: undefined,
        amount: ""
    }), tokenB = ref3[0], setTokenB = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,state_slippage/* useSlippage */.k)(), 1), slippage = ref4[0];
    var amountA = (0,useToBigNumber/* useToBigNumber */.E)(tokenA === null || tokenA === void 0 ? void 0 : tokenA.amount);
    var amountB = (0,useToBigNumber/* useToBigNumber */.E)(tokenB === null || tokenB === void 0 ? void 0 : tokenB.amount);
    var ref5 = (0,useTokenBalance/* useTokenBalance */.m)(tokenA === null || tokenA === void 0 ? void 0 : tokenA.token), currentTokenAbalance = ref5.balance;
    var router = (0,useRouterContract/* useRouterContract */.T)();
    var ref6 = (0,react.useState)(), tradeType = ref6[0], setTradeType = ref6[1];
    (0,react.useEffect)(function() {
        if (token) {
            setTokenA(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    token: token
                });
            });
        }
        if (quotedToken) {
            setTokenB(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    token: quotedToken
                });
            });
        }
    }, [
        token,
        quotedToken
    ]);
    var amountOutMin = (0,react.useMemo)(function() {
        return tradeType == constants_tradeType/* TradeType.EXACT_INPUT */.Y.EXACT_INPUT ? amountB.multipliedBy(1 - slippage) : amountB;
    }, [
        slippage,
        amountB,
        tradeType
    ]);
    var amountInMax = (0,react.useMemo)(function() {
        return tradeType == constants_tradeType/* TradeType.EXACT_OUTPUT */.Y.EXACT_OUTPUT ? amountA.multipliedBy(1 + slippage) : amountA;
    }, [
        slippage,
        amountA,
        tradeType
    ]);
    var ref7 = (0,useBestTrade/* useBestTrade */.P)({
        tokenA: tokenA === null || tokenA === void 0 ? void 0 : tokenA.token,
        tokenB: tokenB === null || tokenB === void 0 ? void 0 : tokenB.token,
        amountIn: amountA,
        amountOut: amountB,
        graph: graph,
        tradeType: tradeType
    }), bestTradePath = ref7.bestTradePath, amountOut = ref7.amountOut, amountIn = ref7.amountIn;
    var ref8 = useSwap(tokenA === null || tokenA === void 0 ? void 0 : tokenA.token, tokenB === null || tokenB === void 0 ? void 0 : tokenB.token, amountInMax, amountOutMin, bestTradePath, tradeType), swapState = ref8.swapState, swap = ref8.swap, setSwapState = ref8.setSwapState, txResult = ref8.txResult, errorSwap = ref8.error;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useApproveCallback/* useApproveCallback */.q)(tokenA === null || tokenA === void 0 ? void 0 : tokenA.token, amountA, router === null || router === void 0 ? void 0 : router.address), 6), TOKEN_A_APPROVAL_STATE = ref9[0], approveTokenA = ref9[1], approvalTxnAState = ref9[2], approvalTxnAResult = ref9[3], setApprovalTxnA = ref9[4], errorApproval = ref9[5];
    var priceImpact = usePriceImpact({
        bestTradingPath: bestTradePath,
        inputAmount: amountA,
        amountOut: amountOut,
        tokenIn: tokenA === null || tokenA === void 0 ? void 0 : tokenA.token,
        tokenOut: tokenB === null || tokenB === void 0 ? void 0 : tokenB.token
    });
    var isSufficientAmount = (0,react.useMemo)(function() {
        if (!(tokenA === null || tokenA === void 0 ? void 0 : tokenA.token) || !currentTokenAbalance || !amountA) {
            return false;
        }
        return currentTokenAbalance === null || currentTokenAbalance === void 0 ? void 0 : currentTokenAbalance.gte((0,formatBalance/* getDecimalAmount */.Qe)(amountA, tokenA.token.decimal));
    }, [
        tokenA,
        currentTokenAbalance,
        amountA
    ]);
    var isPriceImpactTooHigh = (0,react.useMemo)(function() {
        return priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.gt(slippage * 100);
    }, [
        priceImpact,
        slippage
    ]);
    (0,react.useEffect)(function() {
        if ((amountOut === null || amountOut === void 0 ? void 0 : amountOut.gt(0)) && tradeType == constants_tradeType/* TradeType.EXACT_INPUT */.Y.EXACT_INPUT) {
            setTokenB(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    amount: amountOut.toString()
                });
            });
        }
    }, [
        amountOut,
        tradeType
    ]);
    (0,react.useEffect)(function() {
        if ((amountIn === null || amountIn === void 0 ? void 0 : amountIn.gt(0)) && tradeType == constants_tradeType/* TradeType.EXACT_OUTPUT */.Y.EXACT_OUTPUT) {
            setTokenA(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    amount: amountIn.toString()
                });
            });
        }
    }, [
        amountIn,
        tradeType
    ]);
    var onSwitchToken = function() {
        setTokenA(tokenB);
        setTokenB(tokenA);
        setTradeType((0,constants_tradeType/* toggleTradeType */.k)(tradeType));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
            direction: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_6CSUKJP7/* Box */.xu, {
                    borderRadius: "12",
                    background: "blackAlpha.300",
                    maxWidth: "480px",
                    minWidth: {
                        base: "100%",
                        lg: "480px"
                    },
                    p: {
                        base: 1,
                        lg: "5"
                    },
                    py: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WaitForConfirmationModal/* WaitForConfirmationModal */.x, {
                            txState: swapState || approvalTxnAState,
                            setTxState: swapState ? setSwapState : setApprovalTxnA,
                            blockHash: (txResult === null || txResult === void 0 ? void 0 : txResult.blockHash) || (approvalTxnAResult === null || approvalTxnAResult === void 0 ? void 0 : approvalTxnAResult.blockHash)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TxnSuccessModal/* TxSuccessModal */.b, {
                            txState: swapState || approvalTxnAState,
                            setTxState: swapState ? setSwapState : setApprovalTxnA,
                            blockHash: (txResult === null || txResult === void 0 ? void 0 : txResult.blockHash) || (approvalTxnAResult === null || approvalTxnAResult === void 0 ? void 0 : approvalTxnAResult.blockHash)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TxnErrorModal/* TxErrorModal */.f, {
                            txState: swapState || approvalTxnAState,
                            setTxState: swapState ? setSwapState : setApprovalTxnA,
                            error: errorSwap || errorApproval
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_SRMZVY4F/* Container */.W, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_B2MGPQRJ/* Heading */.X, {
                                            as: "h1",
                                            fontSize: {
                                                base: 16,
                                                lg: 24
                                            },
                                            mb: "5",
                                            children: t("Swap")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6FWJQRCB/* Spacer */.L, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapSettingIcon, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_O5CRURSQ/* Stack */.K, {
                                    spacing: "2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectToken/* SelectToken */.a, {
                                            title: "From",
                                            showMax: true,
                                            setNativeTokenAsDefault: true,
                                            token: tokenA === null || tokenA === void 0 ? void 0 : tokenA.token,
                                            excludeToken: tokenB.token,
                                            setToken: function(token) {
                                                return setTokenA(function(prev) {
                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                        token: token
                                                    });
                                                });
                                            },
                                            inputAmount: tokenA === null || tokenA === void 0 ? void 0 : tokenA.amount,
                                            setInputAmount: function(amount) {
                                                setTokenA(function(prev) {
                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                        amount: amount
                                                    });
                                                });
                                                setTradeType(constants_tradeType/* TradeType.EXACT_INPUT */.Y.EXACT_INPUT);
                                            },
                                            transactionState: swapState
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_MPFPK3CX/* Flex */.k, {
                                            className: "hoge",
                                            justifyContent: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchTokenButton, {
                                                onHandleClick: onSwitchToken,
                                                m: {
                                                    base: "-12px",
                                                    lg: "-25px"
                                                },
                                                "aria-label": ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectToken/* SelectToken */.a, {
                                            title: "To",
                                            token: tokenB.token,
                                            excludeToken: tokenA.token,
                                            setToken: function(token) {
                                                return setTokenB(function(prev) {
                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                        token: token
                                                    });
                                                });
                                            },
                                            inputAmount: tokenB === null || tokenB === void 0 ? void 0 : tokenB.amount,
                                            setInputAmount: function(amount) {
                                                setTokenB(function(prev) {
                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                        amount: amount
                                                    });
                                                });
                                                setTradeType(constants_tradeType/* TradeType.EXACT_OUTPUT */.Y.EXACT_OUTPUT);
                                            },
                                            showMax: false,
                                            transactionState: swapState
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6FWJQRCB/* Spacer */.L, {
                                    mt: 3
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SlippageTolerance, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_O5CRURSQ/* Stack */.K, {
                                    mt: "5",
                                    children: [
                                        !isSufficientAmount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_NAA7TEES/* Button */.z, {
                                            isDisabled: true,
                                            fontSize: {
                                                base: 14,
                                                lg: 16
                                            },
                                            children: [
                                                "Insufficient ",
                                                tokenA === null || tokenA === void 0 ? void 0 : (ref = tokenA.token) === null || ref === void 0 ? void 0 : ref.symbol,
                                                " balance"
                                            ]
                                        }),
                                        isSufficientAmount && isPriceImpactTooHigh && /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_NAA7TEES/* Button */.z, {
                                            isDisabled: true,
                                            colorScheme: "red",
                                            fontSize: {
                                                base: 14,
                                                lg: 16
                                            },
                                            children: "Price Impact Too High"
                                        }),
                                        (((ref1 = tokenA.token) === null || ref1 === void 0 ? void 0 : ref1.isNative) || TOKEN_A_APPROVAL_STATE) && (tokenA === null || tokenA === void 0 ? void 0 : tokenA.token) && isSufficientAmount && !isPriceImpactTooHigh && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapButton, {
                                            token: tokenA.token,
                                            approveState: TOKEN_A_APPROVAL_STATE,
                                            swap: swap,
                                            approve: approveTokenA
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6CSUKJP7/* Box */.xu, {
                    mt: 5,
                    mb: 2,
                    children: (tokenB === null || tokenB === void 0 ? void 0 : tokenB.token) && amountB && (tokenA === null || tokenA === void 0 ? void 0 : tokenA.token) && amountA && priceImpact && amountInMax && /*#__PURE__*/ (0,jsx_runtime.jsx)(Details, {
                        minimumAmountReceived: amountOutMin.toFixed(5),
                        maxAmountSold: amountInMax.toFixed(5),
                        outToken: tokenB.token,
                        inToken: tokenA.token,
                        amountIn: amountA,
                        hop: bestTradePath === null || bestTradePath === void 0 ? void 0 : bestTradePath.length,
                        priceImpact: priceImpact,
                        tradeType: tradeType
                    })
                }),
                bestTradePath && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_YGVX4ESO/* Divider */.i, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6CSUKJP7/* Box */.xu, {
                            mt: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoutePath, {
                                routePath: bestTradePath
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./pages/swap/[[...slug]].tsx
// @ts-ignore






var SwapPage = function() {
    var router = (0,next_router.useRouter)();
    var slug = router.query.slug;
    var ref = (0,_sliced_to_array/* default */.Z)(slug ? slug : [
        undefined,
        undefined
    ], 2), tokenAddress = ref[0], quotedTokenAddress = ref[1];
    var token = (0,useFindTokenByAddressOrSymbol/* useFindTokenByAddressOrSymbol */.p)(tokenAddress);
    var quotedToken = (0,useFindTokenByAddressOrSymbol/* useFindTokenByAddressOrSymbol */.p)(quotedTokenAddress);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Swap, {
            token: token,
            quotedToken: quotedToken
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (SwapPage);
 // @ts-ignore


/***/ }),

/***/ 99564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useSlippage; }
/* harmony export */ });
/* unused harmony export currentSlippage */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21157);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43795);
/* harmony import */ var _localStorageEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10220);




var DEFAULT_SLIPPAGE = 0.01;
var MIN_SLIPPAGE = 0.001;
var MAX_SLIPPAGE = 0.50;
var currentSlippage = (0,recoil__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)({
    key: "currentSlippage",
    default: DEFAULT_SLIPPAGE,
    effects: [
        (0,_localStorageEffect__WEBPACK_IMPORTED_MODULE_2__/* .localStorageEffect */ .N)("currentSlippage")
    ]
});
var useSlippage = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), didMount = ref[0], setDidMount = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilState */ .FV)(currentSlippage), 2), slippage = ref1[0], setSlippageRaw = ref1[1];
    var setSlippage = function(num) {
        if (num < MIN_SLIPPAGE) {
            throw "INSUFFICIENT INPUT AMOUNT";
        }
        if (num > MAX_SLIPPAGE) {
            throw "EXCEED MAXMIUM AMOUNT";
        }
        setSlippageRaw(num);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setDidMount(true);
    }, []);
    return [
        didMount ? slippage : DEFAULT_SLIPPAGE,
        setSlippage
    ];
};


/***/ }),

/***/ 3977:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ SearchIcon; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22873);
// src/Search.tsx

var SearchIcon = (0,_chakra_ui_icon__WEBPACK_IMPORTED_MODULE_0__/* .createIcon */ .I)({
  d: "M23.384,21.619,16.855,15.09a9.284,9.284,0,1,0-1.768,1.768l6.529,6.529a1.266,1.266,0,0,0,1.768,0A1.251,1.251,0,0,0,23.384,21.619ZM2.75,9.5a6.75,6.75,0,1,1,6.75,6.75A6.758,6.758,0,0,1,2.75,9.5Z",
  displayName: "SearchIcon"
});




/***/ }),

/***/ 34598:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75249);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98186);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94976);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76143);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49961);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63256);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
// src/input.tsx




var Input = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(function Input2(props, ref) {
  const { htmlSize, ...rest } = props;
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useMultiStyleConfig */ .jC)("Input", rest);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(rest);
  const input = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_4__/* .useFormControl */ .Y)(ownProps);
  const _className = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-input", props.className);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_6__/* .chakra.input */ .m.input,
    {
      size: htmlSize,
      ...input,
      __css: styles.field,
      ref,
      className: _className
    }
  );
});
Input.displayName = "Input";
Input.id = "Input";




/***/ }),

/***/ 38322:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InputLeftElement; }
/* harmony export */ });
/* unused harmony export InputRightElement */
/* harmony import */ var _chunk_7MR544DA_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93278);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49961);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98186);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63256);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);


// src/input-element.tsx



var StyledInputElement = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m)("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    zIndex: 2
  }
});
var InputElement = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(function InputElement2(props, ref) {
  var _a, _b;
  const { placement = "left", ...rest } = props;
  const styles = (0,_chunk_7MR544DA_mjs__WEBPACK_IMPORTED_MODULE_3__/* .useInputGroupStyles */ .m)();
  const input = styles.field;
  const attr = placement === "left" ? "insetStart" : "insetEnd";
  const elementStyles = {
    [attr]: "0",
    width: (_a = input == null ? void 0 : input.height) != null ? _a : input == null ? void 0 : input.h,
    height: (_b = input == null ? void 0 : input.height) != null ? _b : input == null ? void 0 : input.h,
    fontSize: input == null ? void 0 : input.fontSize,
    ...styles.element
  };
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledInputElement, { ref, __css: elementStyles, ...rest });
});
InputElement.id = "InputElement";
InputElement.displayName = "InputElement";
var InputLeftElement = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(
  function InputLeftElement2(props, ref) {
    const { className, ...rest } = props;
    const _className = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-input__left-element", className);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      InputElement,
      {
        ref,
        placement: "left",
        className: _className,
        ...rest
      }
    );
  }
);
InputLeftElement.id = "InputLeftElement";
InputLeftElement.displayName = "InputLeftElement";
var InputRightElement = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .G)(
  function InputRightElement2(props, ref) {
    const { className, ...rest } = props;
    const _className = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-input__right-element", className);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      InputElement,
      {
        ref,
        placement: "right",
        className: _className,
        ...rest
      }
    );
  }
);
InputRightElement.id = "InputRightElement";
InputRightElement.displayName = "InputRightElement";




/***/ }),

/***/ 23908:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98186);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76143);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94976);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49961);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63256);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
// src/container.tsx



var Container = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(function Container2(props, ref) {
  const { className, centerContent, ...rest } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .omitThemingProps */ .Lr)(props);
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useStyleConfig */ .mq)("Container", props);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.div */ .m.div,
    {
      ref,
      className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-container", className),
      ...rest,
      __css: {
        ...styles,
        ...centerContent && {
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }
      }
    }
  );
});
Container.displayName = "Container";




/***/ }),

/***/ 17323:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useToast; }
/* harmony export */ });
/* unused harmony export use_toast_default */
/* harmony import */ var _chunk_ZP4IHIHZ_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82924);
/* harmony import */ var _chunk_RANSABEB_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96980);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80000);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);



// src/use-toast.tsx


function useToast(options) {
  const { theme } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useChakra */ .uP)();
  const defaultOptions = (0,_chunk_ZP4IHIHZ_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useToastOptionContext */ .OX)();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => (0,_chunk_RANSABEB_mjs__WEBPACK_IMPORTED_MODULE_3__/* .createToastFn */ .Cj)(theme.direction, {
      ...defaultOptions,
      ...options
    }),
    [options, theme.direction, defaultOptions]
  );
}
var use_toast_default = (/* unused pure expression or super */ null && (useToast));




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [617,162,125,685,302,873,455,774,888,179], function() { return __webpack_exec__(79020); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);